import FacultyGrid from '@components/sections/FacultyGrid'
import styles from './OurServices.module.css'

const OurServices = () => {
  return (
    <div className={styles.ourServices}>
      <FacultyGrid />
    </div>
  )
}

export default OurServices
